/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable react-hooks/exhaustive-deps */
import { forwardRef, useEffect, useState } from 'react';

import { styled } from '@styles/stitches';

const Canvas = styled('canvas', {
  width: '100%',

  '&:after': {
    content: '',
    display: 'block',
    paddingTop: 'calc(1 * 100%);',
  },
});

interface ICanvasBoardGenerator {
  images: string[];
}

const SIZE = 960;

export const CanvasBoardGenerator = forwardRef<HTMLCanvasElement, ICanvasBoardGenerator>(({ images }, forwardedRef) => {
  const [img, setImg] = useState<HTMLImageElement[]>([]);

  const drawImages = async () => {
    const cvs = (forwardedRef as any).current;

    if (cvs) {
      const ctx = cvs.getContext('2d');
      ctx.clearRect(0, 0, cvs.width, cvs.height);
      ctx.imageSmoothingEnabled = false;
      // first
      if (img[0]) {
        const imgSize = Math.min(img[0].width, img[0].height);
        const left = (img[0].width - imgSize) / 2;
        const top = (img[0].height - imgSize) / 2;
        ctx.drawImage(img[0], left, top, imgSize, imgSize, 0, 0, SIZE * 0.5, SIZE * 0.5);
      }
      // second
      if (img[1]) {
        const imgSize = Math.min(img[1].width, img[1].height);
        const left = (img[1].width - imgSize) / 2;
        const top = (img[1].height - imgSize) / 2;
        ctx.drawImage(img[1], left, top, imgSize, imgSize, SIZE * 0.5, 0, SIZE * 0.5, SIZE * 0.5);
      }
      // third
      if (img[2]) {
        const imgSize = Math.min(img[2].width, img[2].height);
        const left = (img[2].width - imgSize) / 2;
        const top = (img[2].height - imgSize) / 2;
        ctx.drawImage(img[2], left, top, imgSize, imgSize, 0, SIZE * 0.5, SIZE * 0.5, SIZE * 0.5);
      }
      // forth
      if (img[3]) {
        const imgSize = Math.min(img[3].width, img[3].height);
        const left = (img[3].width - imgSize) / 2;
        const top = (img[3].height - imgSize) / 2;
        ctx.drawImage(img[3], left, top, imgSize, imgSize, SIZE * 0.5, SIZE * 0.5, SIZE * 0.5, SIZE * 0.5);
      }
    }
  };

  useEffect(() => {
    const nextImages: HTMLImageElement[] = [];

    // load images in sequence so we always insure the order is kept.
    const loadSingleImage = (current: number, total: number, callback: () => void) => {
      const image = new Image();
      image.crossOrigin = 'anonymous';
      image.onload = () => {
        nextImages.push(image);

        if (current < total) {
          loadSingleImage(current + 1, total, callback);
        }

        if (current === total) {
          callback();
        }
      };
      image.src = images[current];
    };

    if (images.length > 0) {
      loadSingleImage(0, images.length - 1, () => setImg(nextImages));
    } else {
      setImg([]);
      drawImages();
    }
  }, [images]);

  useEffect(() => {
    drawImages();
  }, [img]);

  return <Canvas ref={forwardedRef} width={SIZE} height={SIZE} css={{ backgroundColor: '$secondaryBackground' }} />;
});

CanvasBoardGenerator.displayName = 'canvasBoardGenerator';
